import isEmpty from "@/commons/isEmpty";
import {format as formatDate, formatISO, parse as parseDate} from 'date-fns'

export default {
    model: {
        prop: 'value',
        event: 'input'
    },
    props: {
        value: {},
    },
    data() {
        return {
            inputFormat: null
        }
    },
    computed: {
        inputValue() {
            let dt
            if (isEmpty(this.value)) return null
            if (this.format === 'ISO') {
                dt = Date.parse(this.value)
            } else {
                dt = parseDate(this.value, this.format, new Date())
            }
            return formatDate(dt, this.inputFormat)
        },
    },
    methods: {
        input(val) {
            if (this.format && !isEmpty(val)) {
                if (this.format === 'ISO') {
                    //convert to ISO in local timezone. eg: 2024-08-21T01:00:00+01:00
                    //val = formatISO(Date.parse(val))
                    //always convert to ISO in UTC. eg: 2024-08-21T00:00:00Z
                    val = new Date(Date.parse(val)).toISOString()
                } else {
                    let dt = parseDate(val, this.inputFormat, new Date())
                    val = formatDate(dt, this.format)
                }
            }
            this.$emit('input', val)
        }
    }
}
